import apiClient from './client';

export const authApi = {
  login: async (data) => {
    const response = await apiClient.post('/api/v1/auth/login', data);
    return response.data;
  },

  register: async (data) => {
    const response = await apiClient.post('/api/v1/auth/register', data);
    return response.data;
  },

  getMe: async () => {
    const response = await apiClient.get('/api/v1/auth/me');
    return response.data;
  },

  logout: async (refreshToken) => {
    await apiClient.post('/api/v1/auth/logout', { refresh_token: refreshToken });
  }
};
